import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export const SERVICES = [
    { id: 'urbain', title: 'Courses urbaines', description: 'Déplacements en ville rapides et confortables.' },
    { id: 'longue-distance', title: 'Longues distances', description: 'Trajets inter-villes avec confort haut de gamme.' },
    { id: 'gare-aeroport', title: 'Transferts gares & aéroports', description: 'Ponctualité garantie pour vos vols et trains.' },
    { id: 'scolaire', title: 'Transport scolaire', description: 'Ramassage et dépose en toute sécurité.' },
    { id: 'professionnel', title: 'Transport professionnel', description: 'Déplacements business sans contrainte.' },
    { id: 'chauffeur-prive', title: 'Chauffeur privé', description: 'Votre chauffeur dédié à la journée.' },
    { id: 'mise-disposition', title: 'Mise à disposition', description: 'Véhicule et chauffeur à votre disposition.' },
    { id: 'vip', title: 'Transport VIP', description: 'Service d\'exception, discrétion absolue.' },
    { id: 'medical', title: 'Médical conventionné', description: 'Transport assis conventionné CPAM.' },
    { id: 'hospitalier', title: 'Accompagnement hospitalier', description: 'Soutien lors des rendez-vous médicaux.' },
    { id: 'touristique', title: 'Circuits touristiques', description: 'Découvrez la région avec un chauffeur.' },
    { id: 'visite-guidee', title: 'Visites guidées', description: 'Excursions personnalisées sur mesure.' },
    { id: 'navette-entreprise', title: 'Navettes entreprises', description: 'Transport collectif pour vos équipes.' },
    { id: 'evenementiel', title: 'Transport événementiel', description: 'Galas, séminaires, conférences.' },
    { id: 'mariage', title: 'Mariages & soirées', description: 'Le luxe pour vos plus beaux moments.' },
    { id: 'pmr', title: 'Transport PMR', description: 'Véhicule adapté personnes à mobilité réduite.' },
    { id: 'seniors', title: 'Personnes âgées', description: 'Accompagnement attentionné et patient.' },
    { id: 'enfants', title: 'Transport d\'enfants', description: 'Trajets sécurisés avec sièges adaptés.' },
    { id: 'colis', title: 'Livraison de colis', description: 'Acheminement rapide de documents et colis.' },
    { id: 'express', title: 'Courses express', description: 'Intervention rapide 24/7.' },
    { id: 'navette-hotel', title: 'Navette hôtelière', description: 'Service VIP pour vos clients hôteliers.' },
    { id: 'service-24-7', title: 'Service 24h/24 & 7j/7', description: 'Disponible jour et nuit, sans exception.' },
];

export const VEHICLES = [
    { id: 'tesla_model_y', label: 'Tesla Model Y', desc: '100 % électrique — jusqu\'à 4 passagers', maxPax: 4 },
    { id: 'van', label: 'Van', desc: 'Spacieux — jusqu\'à 8 passagers', maxPax: 8 },
];
export const VEHICLE = VEHICLES[0];
